/* eslint-disable */
import * as Types from '../../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type QuoteTemplateUpdateSubscribedVersionButton_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, hasOverridesDefined: boolean, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number } | null };

export const QuoteTemplateUpdateSubscribedVersionButton_QuoteTemplateFragmentDoc = gql`
    fragment QuoteTemplateUpdateSubscribedVersionButton_QuoteTemplate on QuoteTemplate {
  id
  resolvedAsReadModelVersionNumber
  templateSharing {
    id
    latestSharedVersionNumber
  }
  hasOverridesDefined
}
    `;